export class Address {
  street: string;
  zip: string;
  city: string;
  technicalZip: string;
}
